import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse, Text, TextFeature, TextSize } from '@as/cotopaxi';
import { Divider } from '@yonderland/andes-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { GlossaryHighlighter } from '../../glossary/GlossaryHighlighter';
export const MiniPDPDescription = ({ description }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const containerRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Collapse, { id: "mini-pdp-description", title: t('pdp.mini.description'), hasDivider: false, children: _jsx("div", { "data-glossary": "popover", ref: containerRef, children: _jsx(Text, { feature: TextFeature.PRODUCT_TECHNICAL_DESCRIPTION, size: TextSize.SMALL, dataQA: "product_description", children: _jsx(HtmlInclude, { htmlFragment: description }) }) }) }), _jsx(GlossaryHighlighter, { container: containerRef, isInsidePopover: true })] }));
};
